/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DeleteManyRequestV1 } from '../models/DeleteManyRequestV1';
import type { DeleteManyResultV1 } from '../models/DeleteManyResultV1';
import type { ServiceObjectTypeCreateV1Dto } from '../models/ServiceObjectTypeCreateV1Dto';
import type { ServiceObjectTypePatchV1Dto } from '../models/ServiceObjectTypePatchV1Dto';
import type { ServiceObjectTypeV1Dto } from '../models/ServiceObjectTypeV1Dto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ServiceObjectTypesService {
  /**
   * @param requestBody The object type to create.
   * @returns ServiceObjectTypeCreateV1Dto create entity
   * @throws ApiError
   */
  public static serviceObjectTypeControllerV1CreateV1(
    requestBody: ServiceObjectTypeCreateV1Dto,
  ): CancelablePromise<ServiceObjectTypeCreateV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/service-object-types',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param requestBody ids of object types to delete
   * @returns DeleteManyResultV1 batch delete result
   * @throws ApiError
   */
  public static serviceObjectTypeControllerV1RemoveManyV1(
    requestBody: DeleteManyRequestV1,
  ): CancelablePromise<DeleteManyResultV1> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/service-object-types',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @returns ServiceObjectTypeV1Dto a entity list
   * @throws ApiError
   */
  public static serviceObjectTypeControllerV1FindAllV1(): CancelablePromise<
    Array<ServiceObjectTypeV1Dto>
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/service-object-types',
      errors: {
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param uuid serviceObjectTypeId
   * @returns ServiceObjectTypeV1Dto the entity
   * @throws ApiError
   */
  public static serviceObjectTypeControllerV1RemoveOneV1(
    uuid: string,
  ): CancelablePromise<ServiceObjectTypeV1Dto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/service-object-types/{uuid}',
      path: {
        uuid: uuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param uuid
   * @returns ServiceObjectTypeV1Dto The object type with the specified id.
   * @throws ApiError
   */
  public static serviceObjectTypeControllerV1FindOneV1(
    uuid: string,
  ): CancelablePromise<ServiceObjectTypeV1Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/service-object-types/{uuid}',
      path: {
        uuid: uuid,
      },
    });
  }
  /**
   * @param uuid serviceObjectTypeId
   * @param requestBody The object type data to update.
   * @returns ServiceObjectTypeV1Dto the entity
   * @throws ApiError
   */
  public static serviceObjectTypeControllerV1UpdatePartialV1(
    uuid: string,
    requestBody: ServiceObjectTypePatchV1Dto,
  ): CancelablePromise<ServiceObjectTypeV1Dto> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/v1/service-object-types/{uuid}',
      path: {
        uuid: uuid,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
}
